import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../utils/api';

interface Product {
  id: number;
  name: string;
  price: string;
  image: string;
  short_description: string;
  category_name: string;
}

const Home: React.FC = () => {
  const [featured, setFeatured] = useState<Product[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    api.get('/test-full.php?action=api-products')
      .then(response => {
        const data = response.data;
        if (data.success && Array.isArray(data.data)) {
          setFeatured(data.data.filter((p: any) => p.is_featured == 1));
        } else {
          setError('داده‌ها به درستی دریافت نشدند.');
        }
        setLoading(false);
      })
      .catch(err => {
        console.error('Error loading products:', err);
        setError('خطا در بارگذاری محصولات: ' + err.message);
        setLoading(false);
      });
  }, []);

  if (loading) return <div className="loading">در حال بارگذاری...</div>;
  if (error) return <div className="alert alert-error">{error}</div>;

  return (
    <>
      <section className="hero-slider" style={{ background: 'linear-gradient(135deg, #D6ECD7, #a8d5ba)', padding: '60px 0', textAlign: 'center' }}>
        <div className="container">
          <h1 style={{ fontSize: '42px', color: '#1e3a1e' }}>به <strong style={{ color: '#2E7D32' }}>سبزه میدون</strong> خوش آمدید</h1>
          <p style={{ fontSize: '18px', color: '#3a5a3a', marginTop: '10px' }}>تأمین کننده تخصصی نهاده‌های کشاورزی</p>
          <Link to="/shop" className="btn btn-primary" style={{ marginTop: '20px' }}>مشاهده محصولات</Link>
        </div>
      </section>

      <section style={{ padding: '40px 0' }}>
        <div className="container">
          <h2 style={{ fontSize: '28px', marginBottom: '30px', color: '#1e3a1e' }}>محصولات ویژه</h2>
          <div className="product-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))', gap: '25px' }}>
            {featured.length > 0 ? (
              featured.map(p => (
                <div key={p.id} style={{ background: '#fff', borderRadius: '16px', padding: '20px', boxShadow: '0 4px 20px rgba(0,0,0,0.06)', textAlign: 'center' }}>
                  <img 
                    src={`https://fellfell.ir/uploads/products/${p.image || 'default.jpg'}`} 
                    alt={p.name} 
                    style={{ width: '100%', height: '200px', objectFit: 'cover', borderRadius: '12px', marginBottom: '15px' }}
                    onError={(e) => { e.currentTarget.src = 'https://fellfell.ir/assets/images/product-placeholder.jpg'; }}
                  />
                  <h3 style={{ fontSize: '17px', color: '#1e3a1e' }}>{p.name}</h3>
                  <p style={{ fontSize: '13px', color: '#888', margin: '5px 0 10px' }}>{p.short_description}</p>
                  <p className="price" style={{ color: '#2E7D32', fontSize: '20px', fontWeight: 'bold' }}>
                    {new Intl.NumberFormat('fa-IR').format(Number(p.price))} تومان
                  </p>
                  <Link to={`/product/${p.id}`} className="btn btn-primary" style={{ marginTop: '10px' }}>مشاهده</Link>
                </div>
              ))
            ) : (
              <p>محصولی برای نمایش وجود ندارد.</p>
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export default Home;